module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("In which I fall in love")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sunday, July 19, 1778.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is talk of a new family in town, a woman and her son. At church I saw them after mass. The boy—about sixteen, I guessed, and comely—was watching three village boys chase a scorpion that had slipped under a pew. He fiddled with the handle of his cutlass, his long dark bangs hiding his eyes. His linen frock and leather breeches were patched.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Béké-goyave,” Mother said under her breath, pushing me outside, “vagabonds!”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("July 25.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mother allowed me to go with Mimi and Sylvester to market today. “So long as your chores are done,” she said. We set off for town in the back of the ox-cart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was busy in the village; I confess I was hoping to see the new boy, but there were only sailors who’d come over from Fort-Royal for the cock-fights. I kept my eyes to the ground, the way the nuns had taught.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the dock we bought a bonito and three coral fish from a fisherman with light frizzy hair. He stared at me while we went through his catch. Then he said something to Sylvester and laughed in a way that made me blush.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("We walked back up to the village square to buy pawpaws, guavas, avocado pears and tapioca. At a table displaying pictures of the saints, little mirrors and beads, a woman told us about the runaway slave who had turned into a dog and eaten a baby on the Desfieux plantation. Just at ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("the frightful part the new boy’s mother arrived, followed at some distance by the boy, laden with parcels.")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("His mother nodded at me, her eyes deep set. “I saw you at church,” she said. She talked like a nun, proper. Between sentences she pressed her lips together.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I nodded. She introduced herself as Madame Browder, a British name. The boy’s name is William.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re at the foot of Morne Croc-Souris,” I told them.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mimi spat onto the dirt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“On the river?” Madame Browder asked, tucking a wisp of red hair under her plain white téte.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Farther on, La Pagerie.” From across the bay, I could see a gommier making its way slowly to the shore. A swarm of gulls hovered above it like mosquitoes in rainy season.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re closer in toward town,” Madame Browder said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The old Laignelot homestead,” Mimi said. She was scratching the ears of a mangy dog. “Neighbours, if you go by the river.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I felt I should invite them for tea and cakes, but I dared not, remembering my mother’s harsh words: béké-goyave. I was saved by Sylvester pulling up in the wagon. Hurriedly I took my leave.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sweet eyes,” Mimi teased on the way home, jabbing me with her elbow. “I saw you making sweet eyes.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sunday, August 9.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("William and his mother sat near the front of church this morning. Mother, Manette (who is better now) and I sat on a bench several rows behind. All through mass I watched him, my heart fluttering like a trapped baby bird.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("August 10.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("I sneaked down to the lower pond this afternoon for a swim. But when I got there I saw the new boy William Browder. He was fishing, his pantaloons rolled up to his knees. He startled when he saw me, as if he ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("shouldn’t be there. He pulled his line out of the water, a long length of white horsehair attached to a bamboo pole.")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Caught anything?” It was hot and I longed to go in, but I didn’t know if I should, now that he was there. Instead I sat down on the bank. I picked a long blade of razor grass and split it so I could whistle through it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How do you do that?” William Browder asked, rolling down his pantaloons.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I showed him and we sat whistling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why did you move to Trois-Ilets?” I asked finally. Cul-de-sac à vaches—cow-field—that’s what we call it. “Not that it’s my business,” I added, in an attempt to show manners.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It was hard for my mother in Saint-Pierre,” he said. He looked up at the sky. A hawk was circling. “It’s hard for her here, too.” He shrugged.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’d heard that his mother used to be an actress, that she’d fallen in love with a sailor in the British navy during the Seven Years’ War. Imagine having a mother like that, I thought. An actress! The shame and the glory of it. An actress couldn’t be buried in a church graveyard, or even marry—the Church forbade it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re English? But you don’t have an accent.” I swatted at a red ant crawling up my arm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My father was from Scotland actually.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I didn’t know where Scotland was, but I was relieved he wasn’t British. The British are not Christian—they eat children.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I never knew him,” he went on. He stretched out on the grass, twirling a blade of grass between his fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Never?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William looked at me. His eyes were the lightest blue I’d ever seen. “I remember his face, remember him smiling. But that’s all.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“My father is rarely home, so I don’t suppose it’s that much different,” I told him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When I was young,” William said, “I liked to think that my mother and father had loved each other very much, and had parted tragically. I thought that better than some long drawn-out marriage where the husband and wife only grow bitter and cold.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("A fish jumped from the water, making rings over the glassy surface of the ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("pond. I thought of my own mother and father, of the bitterness between them. Had there ever been love?")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("William pushed his hair away from his eyes. “I’m a romantic, I guess.” He smiled. “Like my hero, Jean-Jacques Rousseau.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I got to my feet, uneasy. No one, most especially a boy, had ever talked to me about such things. I feared it was improper and didn’t know how to respond. “I must go,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes,” William said, also rising. He stood before me, awkward and hesitant, no longer a mysterious young man, the son of an actress who had been tragically loved, but instead only William, a béké-goyave in patched clothes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hurried up the trace. At the stone bridge I glanced back. William was watching me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tomorrow?” he called out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I ran up the hill, my face burning.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Wednesday, August 12.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("All morning I told myself: I’m not going to go, I’m not going to go. And then, after chores, there I was, heading for the swimming pond. . . .")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William grinned when he saw me coming down the trace. I pretended to be surprised to see him there. I didn’t know what to say so I sat on the bank and threw pebbles in the water. Then I ran home singing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If anyone ever found out, I hate to think what might become of me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I will never go again.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("September 2.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Whenever I can I go to the fishing pond. William is often there. Mostly we sit and talk. I tell him how I long to go to France, to "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Paris,")]), _vm._v(" how I feel there is so much to experience and see, how exciting it is to be young and looking forward to it all, how hard to be told your dreams are impossible.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("William is the same. He longs to see the world. He reads the journals that come over on the boats. He tells me all about the things that are going on in the American colonies. He talks of “freedom” and “equality.” ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("He asks me what I think about it all, but I tell him I don’t read, so how do I know?")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You don’t have to read to know how you feel about something like freedom. It’s in your heart,” he says, “not in words on a page.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("This afternoon he read a passage from a book: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Man is born free, but is everywhere in chains")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "id": "fn-52"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn52"
    }
  }, [_vm._v("I")]), _vm._v(" "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“Born")]), _vm._v(" free,” he said. “Imagine that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everyone?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Free "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("and")]), _vm._v(" equal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Slaves, too?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“A master and his slaves.” He paused. “A king and his subjects.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("that")]), _vm._v(" what’s written in that book?” I regarded it with apprehension, as if it might burst into flames before my eyes. “But William,” I said, “if that were true, the world would—” I stopped. I couldn’t think of a word big enough.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes!” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Friday, September 18.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("William and I have quarrelled. It started when I told him Mimi casts my cards, that she’s teaching me how.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How can your life be in those little pieces of paper?” he demanded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I just know the cards are right. I have seen that it is so.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t believe in freedom then,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Show me freedom!” I cried, and he had no answer. For there is no such thing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("September 20, 8:30 "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("P.M.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("William has apologized and I have accepted. He confessed that it distressed him to think that there might be no such thing as freedom, that everything was written. “Then what would it matter what a person did?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I told him about Catherine, and the fortune the old woman had given her, and how it had so tragically come to pass. Then I told him about the fortune the old woman had given me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("“Do you believe this is your destiny—to be "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Queen")]), _vm._v(" of France?” he asked.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“How frightful that would be,” I said. A flock of crows was making a racket in some bushes down in a ravine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("William picked a bough of scarlet bougainvillea and crowned my head. He stood back to look at me. “You would make a lovely queen,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned away, for I felt so shamelessly beautiful in his eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He made a mock bow. “But who will be your king?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The bougainvillea fell from my head. I stooped to pick it up. I stood and faced him, suddenly dizzy. “You?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then he kissed me, and I allowed him to do so.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("October 16.")])])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("This afternoon William and I hiked up the mountain in hopes of seeing the green flash."), _c('sup', {
    staticClass: "sup"
  })]), _c('a', {
    attrs: {
      "id": "fn-53"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn53"
    }
  }, [_vm._v("II")]), _vm._v(" We waited until just after dusk, but even so, we did not see it, for too much kissing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Sunday, November 1, All Saints’ Day.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Oh . . . holidays, holidays, holidays, I’m so anxious for them to be over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This morning, after lighting candles at Catherine’s tomb, Mother, Manette and I returned to a holiday “feast” at home: boiled green bananas and féroce. The féroce tasted terrible without salt, which we have had to do without ever since the British blockaded the port."), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "id": "fn-54"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn54"
    }
  }, [_vm._v("III")])]), _vm._v(" We said a prayer for Father, who is engaged in conflict in Sainte-Lucie.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ve not seen William for five days.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("December 15.")])])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The British have captured Sainte-Lucie. Father is safe—he’s on his way home.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("New Year’s Day, 1779.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Today I brought William a gift of ginger sweets. “You have found the way to my heart,” he said. Sometimes he talks like that—like an old-fashioned knight.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("It was hot so we stayed in the water a long time. When we got out we stretched out on the bank to dry. He untied my hair. Then he kissed me and held me close. There were no sounds, no birds singing, only the beating of my heart. I pulled away then, for it frightened me, this.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("“Where have you been?” Mother said when I got home. The shadows had grown long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At the river with Mimi,” I lied.")]), _vm._v(" "), _c('p', {
    staticClass: "indentb"
  }, [_vm._v("“Your cheeks are pink,” she said. “You’re neglecting to wear your bonnet.”")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is night now, late. The hills are silent. I couldn’t sleep so I got up and lit a candle and opened this dear little book, that I might write down the thoughts that burn in my heart.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I love William. I love William. I love William.")]), _vm._v(" "), _c('hr', {
    staticClass: "hr"
  })]), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _c('a', {
    attrs: {
      "id": "fn52"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn-52"
    }
  }, [_vm._v("I")]), _vm._v(". "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("From")]), _vm._v(" The Social Contract "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("by Jean-Jacques Rousseau.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "fn53"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn-53"
    }
  }, [_vm._v("II")]), _vm._v(". "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("A narrow line of green that can occasionally be seen as the sun sets or rises. It is believed to bring luck to those who see it.")])]), _vm._v(" "), _c('p', {
    staticClass: "footnote"
  }, [_c('a', {
    attrs: {
      "id": "fn54"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/#fn-54"
    }
  }, [_vm._v("III")]), _vm._v(". "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("France was unofficially supporting the American War of Independence against England by providing supplies to the American troops from Fort-Royal, so British ships had blockaded the port.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-721179a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 87
// module chunks = 0